import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export const AppLayout: React.FC = () => {
  return (
    <div className="app-container">
      <Header />
      <main className="app-content">
        <Outlet />
      </main>
    </div>
  );
};
